import { render, staticRenderFns } from "./ModalDatosPatente.vue?vue&type=template&id=73658588"
import script from "./ModalDatosPatente.vue?vue&type=script&lang=js"
export * from "./ModalDatosPatente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports